import { memo } from 'react';

const PageContent = memo(({ classNames, children }) => {
	return <div className={`page-content mb-3 ${classNames ? classNames : ''}`}>{children}</div>;
});
export default PageContent;
